import { styled } from '@material-ui/core/styles';

export const OptionsContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.FP200,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const AdditionalInstructionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(0.5, 1),
  gap: theme.spacing(2),
  '& > *:first-child': {
    flex: 1
  }
}));
